// shared/components/toast-host/toast-host.component.ts
import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { TRANSLATION_KEYS } from '../../i18n/translation-keys';
import { Toast, ToastService } from '../../services/toast';

@Component({
  selector: 'app-toast-host',
  standalone: true,
  imports: [NgClass, TranslatePipe, MatTooltipModule],
  templateUrl: './toast-host.html',
  styleUrl: './toast-host.scss',
})
export class ToastHost {
  toastService = inject(ToastService);
  protected readonly translationKeys = TRANSLATION_KEYS;

  protected onAction(toast: Toast): void {
    toast.action?.onClick();
    this.toastService.dismiss(toast.id);
  }
}
